const TZ = 'America/Jamaica';

// en-GB puts a comma after the weekday when there's a year ("Sun, 25 Oct
// 2026"); the design doesn't
const fmt = (iso, options) =>
  new Intl.DateTimeFormat('en-GB', { timeZone: TZ, ...options })
    .format(new Date(iso))
    .replace(/^([A-Za-z]{3}),/, '$1');

// "Fri 23 Oct, 8:00 am – Sun 25 Oct 2026, 8:00 pm" (Jamaica time)
export function meetWhen(start, end, wholeDay) {
  if (!start) return '';
  const day = (iso, withYear) =>
    fmt(iso, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      ...(withYear ? { year: 'numeric' } : {}),
    });
  const time = (iso) =>
    fmt(iso, { hour: 'numeric', minute: '2-digit', hour12: true })
      // Some engines put a narrow no-break space before am/pm
      .replace(/\u202f/g, ' ')
      .toLowerCase();
  const last = end || start;
  const sameDay = day(start, true) === day(last, true);
  if (wholeDay) {
    return sameDay
      ? day(start, true)
      : `${day(start, false)} – ${day(last, true)}`;
  }
  if (sameDay) return `${day(start, true)}, ${time(start)} – ${time(last)}`;
  return `${day(start, false)}, ${time(start)} – ${day(last, true)}, ${time(last)}`;
}

// "Mon 19 Oct"
export function shortDay(iso) {
  return iso
    ? fmt(iso, { weekday: 'short', day: 'numeric', month: 'short' })
    : '';
}

// "Fri 16 Oct 2026, 5:00 pm"
export function deadline(iso) {
  if (!iso) return '';
  return `${fmt(iso, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })}, ${fmt(iso, { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase()}`;
}

export function fileSize(bytes) {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// "PDF", "ZIP", "XLSX"... from the filename, else the content type
export function fileFormat(item) {
  const ext = (item.filename || '').split('.').pop();
  if (ext && ext !== item.filename) return ext.toUpperCase();
  const sub = (item.content_type || '').split('/').pop();
  return sub ? sub.toUpperCase() : 'FILE';
}
